import { useIsFetching } from '@tanstack/react-query';

// Global loading bar that shows at top when any query is fetching
export default function LoadingBar() {
  const isFetching = useIsFetching();

  if (!isFetching) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[99] h-1 bg-surface-200 overflow-hidden">
      <div
        className="h-full bg-gradient-to-r from-primary-500 via-primary-400 to-primary-500 animate-loading-bar"
        style={{
          backgroundSize: '200% 100%'
        }}
      />
    </div>
  );
}
